export const WORKFLOW_SYSTEM_NAME_CONSTANTS = {
	FacetoFace: 'FACETOFACE',
	FacetoFace_DETERMININGFACETOFACESTATUS: 'FACETOFACE.DETERMININGFACETOFACESTATUS',
	FacetoFace_SCHEDULINGFACETOFACEENCOUNTER: 'FACETOFACE.SCHEDULINGFACETOFACEENCOUNTER',
	FacetoFace_UPLOADINGFACETOFACEDOCUMENTATION: 'FACETOFACE.UPLOADINGFACETOFACEDOCUMENTATION',
	FacetoFace_SKIPPED: 'FACETOFACE.SKIPPED',
	FacetoFace_CANCELLED: 'FACETOFACE.CANCELLED',
	FacetoFace_IDLE: 'FACETOFACE.IDLE',
	FacetoFace_PENDING: 'FACETOFACE.PENDING',
	FacetoFace_COMPLETE: 'FACETOFACE.COMPLETE',
	HomeboundStatus: 'HOMEBOUNDSTATUS',
	HomeboundStatus_WAITINGFORINITIALASSESSMENT: 'HOMEBOUNDSTATUS.WAITINGFORINITIALASSESSMENT',
	HomeboundStatus_ASSESSINGHOMEBOUNDSTATUS: 'HOMEBOUNDSTATUS.ASSESSINGHOMEBOUNDSTATUS',
	HomeboundStatus_DOCUMENTED: 'HOMEBOUNDSTATUS.DOCUMENTED',
	HomeboundStatus_SKIPPED: 'HOMEBOUNDSTATUS.SKIPPED',
	HomeboundStatus_CANCELLED: 'HOMEBOUNDSTATUS.CANCELLED',
	HomeboundStatus_IDLE: 'HOMEBOUNDSTATUS.IDLE',
	HomeboundStatus_PENDING: 'HOMEBOUNDSTATUS.PENDING',
	HomeboundStatus_COMPLETE: 'HOMEBOUNDSTATUS.COMPLETE',
	NoticeOfAdmission: 'NOTICEOFADMISSION',
	NoticeOfAdmission_WAITINGONADMISSION: 'NOTICEOFADMISSION.WAITINGONADMISSION',
	NoticeOfAdmission_NEEDSSUBMITTED: 'NOTICEOFADMISSION.NEEDSSUBMITTED',
	NoticeOfAdmission_SKIPPED: 'NOTICEOFADMISSION.SKIPPED',
	NoticeOfAdmission_CANCELLED: 'NOTICEOFADMISSION.CANCELLED',
	NoticeOfAdmission_IDLE: 'NOTICEOFADMISSION.IDLE',
	NoticeOfAdmission_PENDING: 'NOTICEOFADMISSION.PENDING',
	NoticeOfAdmission_COMPLETE: 'NOTICEOFADMISSION.COMPLETE',
	InitialAssessment: 'INITIALASSESSMENT',
	InitialAssessment_DATAENTRY: 'INITIALASSESSMENT.DATAENTRY',
	InitialAssessment_READYFORINITIALASSESSMENT: 'INITIALASSESSMENT.READYFORINITIALASSESSMENT',
	InitialAssessment_INITIALASSESSMENTINPROGRESS: 'INITIALASSESSMENT.INITIALASSESSMENTINPROGRESS',
	InitialAssessment_WAITINGINITIALASSESSMENTBUCKETCOMPLETION: 'INITIALASSESSMENT.WAITINGINITIALASSESSMENTBUCKETCOMPLETION',
	InitialAssessment_PROMPTINGTOADMIT: 'INITIALASSESSMENT.PROMPTINGTOADMIT',
	InitialAssessment_SKIPPED: 'INITIALASSESSMENT.SKIPPED',
	InitialAssessment_CANCELLED: 'INITIALASSESSMENT.CANCELLED',
	InitialAssessment_IDLE: 'INITIALASSESSMENT.IDLE',
	InitialAssessment_PENDING: 'INITIALASSESSMENT.PENDING',
	InitialAssessment_COMPLETE: 'INITIALASSESSMENT.COMPLETE',
	InitialCertification: 'INITIALCERTIFICATION',
	Recertification: 'RECERTIFICATION',
	FrequenciesInitialEvaluation: 'FREQUENCIES.INITIALEVALUATION',
	FrequenciesInitialEvaluation_INPROGRESS: 'FREQUENCIES.INITIALEVALUATION.INPROGRESS',
	FrequenciesInitialEvaluation_SKIPPED: 'FREQUENCIES.INITIALEVALUATION.SKIPPED',
	FrequenciesInitialEvaluation_CANCELLED: 'FREQUENCIES.INITIALEVALUATION.CANCELLED',
	FrequenciesInitialEvaluation_IDLE: 'FREQUENCIES.INITIALEVALUATION.IDLE',
	FrequenciesInitialEvaluation_PENDING: 'FREQUENCIES.INITIALEVALUATION.PENDING',
	FrequenciesInitialEvaluation_COMPLETE: 'FREQUENCIES.INITIALEVALUATION.COMPLETE',
	FrequenciesEvaluationSn: 'FREQUENCIES.EVALUATION.SN',
	FrequenciesEvaluationSn_NEEDSSTAFFED: 'FREQUENCIES.EVALUATION.SN.NEEDSSTAFFED',
	FrequenciesEvaluationSn_NEEDSPERFORMED: 'FREQUENCIES.EVALUATION.SN.NEEDSPERFORMED',
	FrequenciesEvaluationSn_PERFORMING: 'FREQUENCIES.EVALUATION.SN.PERFORMING',
	FrequenciesEvaluationSn_PENDINGMISSEDVISIT: 'FREQUENCIES.EVALUATION.SN.PENDINGMISSEDVISIT',
	FrequenciesEvaluationSn_MISSED: 'FREQUENCIES.EVALUATION.SN.MISSED',
	FrequenciesEvaluationSn_SKIPPED: 'FREQUENCIES.EVALUATION.SN.SKIPPED',
	FrequenciesEvaluationSn_CANCELLED: 'FREQUENCIES.EVALUATION.SN.CANCELLED',
	FrequenciesEvaluationSn_IDLE: 'FREQUENCIES.EVALUATION.SN.IDLE',
	FrequenciesEvaluationSn_PENDING: 'FREQUENCIES.EVALUATION.SN.PENDING',
	FrequenciesEvaluationSn_COMPLETE: 'FREQUENCIES.EVALUATION.SN.COMPLETE',
	FrequenciesEvaluationPt: 'FREQUENCIES.EVALUATION.PT',
	FrequenciesEvaluationPt_NEEDSSTAFFED: 'FREQUENCIES.EVALUATION.PT.NEEDSSTAFFED',
	FrequenciesEvaluationPt_NEEDSPERFORMED: 'FREQUENCIES.EVALUATION.PT.NEEDSPERFORMED',
	FrequenciesEvaluationPt_PERFORMING: 'FREQUENCIES.EVALUATION.PT.PERFORMING',
	FrequenciesEvaluationPt_PENDINGMISSEDVISIT: 'FREQUENCIES.EVALUATION.PT.PENDINGMISSEDVISIT',
	FrequenciesEvaluationPt_MISSED: 'FREQUENCIES.EVALUATION.PT.MISSED',
	FrequenciesEvaluationPt_SKIPPED: 'FREQUENCIES.EVALUATION.PT.SKIPPED',
	FrequenciesEvaluationPt_CANCELLED: 'FREQUENCIES.EVALUATION.PT.CANCELLED',
	FrequenciesEvaluationPt_IDLE: 'FREQUENCIES.EVALUATION.PT.IDLE',
	FrequenciesEvaluationPt_PENDING: 'FREQUENCIES.EVALUATION.PT.PENDING',
	FrequenciesEvaluationPt_COMPLETE: 'FREQUENCIES.EVALUATION.PT.COMPLETE',
	FrequenciesEvaluationOt: 'FREQUENCIES.EVALUATION.OT',
	FrequenciesEvaluationOt_NEEDSSTAFFED: 'FREQUENCIES.EVALUATION.OT.NEEDSSTAFFED',
	FrequenciesEvaluationOt_NEEDSPERFORMED: 'FREQUENCIES.EVALUATION.OT.NEEDSPERFORMED',
	FrequenciesEvaluationOt_PERFORMING: 'FREQUENCIES.EVALUATION.OT.PERFORMING',
	FrequenciesEvaluationOt_PENDINGMISSEDVISIT: 'FREQUENCIES.EVALUATION.OT.PENDINGMISSEDVISIT',
	FrequenciesEvaluationOt_MISSED: 'FREQUENCIES.EVALUATION.OT.MISSED',
	FrequenciesEvaluationOt_SKIPPED: 'FREQUENCIES.EVALUATION.OT.SKIPPED',
	FrequenciesEvaluationOt_CANCELLED: 'FREQUENCIES.EVALUATION.OT.CANCELLED',
	FrequenciesEvaluationOt_IDLE: 'FREQUENCIES.EVALUATION.OT.IDLE',
	FrequenciesEvaluationOt_PENDING: 'FREQUENCIES.EVALUATION.OT.PENDING',
	FrequenciesEvaluationOt_COMPLETE: 'FREQUENCIES.EVALUATION.OT.COMPLETE',
	FrequenciesEvaluationSt: 'FREQUENCIES.EVALUATION.ST',
	FrequenciesEvaluationSt_NEEDSSTAFFED: 'FREQUENCIES.EVALUATION.ST.NEEDSSTAFFED',
	FrequenciesEvaluationSt_NEEDSPERFORMED: 'FREQUENCIES.EVALUATION.ST.NEEDSPERFORMED',
	FrequenciesEvaluationSt_PERFORMING: 'FREQUENCIES.EVALUATION.ST.PERFORMING',
	FrequenciesEvaluationSt_PENDINGMISSEDVISIT: 'FREQUENCIES.EVALUATION.ST.PENDINGMISSEDVISIT',
	FrequenciesEvaluationSt_MISSED: 'FREQUENCIES.EVALUATION.ST.MISSED',
	FrequenciesEvaluationSt_SKIPPED: 'FREQUENCIES.EVALUATION.ST.SKIPPED',
	FrequenciesEvaluationSt_CANCELLED: 'FREQUENCIES.EVALUATION.ST.CANCELLED',
	FrequenciesEvaluationSt_IDLE: 'FREQUENCIES.EVALUATION.ST.IDLE',
	FrequenciesEvaluationSt_PENDING: 'FREQUENCIES.EVALUATION.ST.PENDING',
	FrequenciesEvaluationSt_COMPLETE: 'FREQUENCIES.EVALUATION.ST.COMPLETE',
	FrequenciesEvaluationMsw: 'FREQUENCIES.EVALUATION.MSW',
	FrequenciesEvaluationMsw_NEEDSSTAFFED: 'FREQUENCIES.EVALUATION.MSW.NEEDSSTAFFED',
	FrequenciesEvaluationMsw_NEEDSPERFORMED: 'FREQUENCIES.EVALUATION.MSW.NEEDSPERFORMED',
	FrequenciesEvaluationMsw_PERFORMING: 'FREQUENCIES.EVALUATION.MSW.PERFORMING',
	FrequenciesEvaluationMsw_PENDINGMISSEDVISIT: 'FREQUENCIES.EVALUATION.MSW.PENDINGMISSEDVISIT',
	FrequenciesEvaluationMsw_MISSED: 'FREQUENCIES.EVALUATION.MSW.MISSED',
	FrequenciesEvaluationMsw_SKIPPED: 'FREQUENCIES.EVALUATION.MSW.SKIPPED',
	FrequenciesEvaluationMsw_CANCELLED: 'FREQUENCIES.EVALUATION.MSW.CANCELLED',
	FrequenciesEvaluationMsw_IDLE: 'FREQUENCIES.EVALUATION.MSW.IDLE',
	FrequenciesEvaluationMsw_PENDING: 'FREQUENCIES.EVALUATION.MSW.PENDING',
	FrequenciesEvaluationMsw_COMPLETE: 'FREQUENCIES.EVALUATION.MSW.COMPLETE',
	FrequenciesEvaluationHha: 'FREQUENCIES.EVALUATION.HHA',
	FrequenciesEvaluationHha_INPROGRESS: 'FREQUENCIES.EVALUATION.HHA.INPROGRESS',
	FrequenciesEvaluationHha_SKIPPED: 'FREQUENCIES.EVALUATION.HHA.SKIPPED',
	FrequenciesEvaluationHha_CANCELLED: 'FREQUENCIES.EVALUATION.HHA.CANCELLED',
	FrequenciesEvaluationHha_IDLE: 'FREQUENCIES.EVALUATION.HHA.IDLE',
	FrequenciesEvaluationHha_PENDING: 'FREQUENCIES.EVALUATION.HHA.PENDING',
	FrequenciesEvaluationHha_COMPLETE: 'FREQUENCIES.EVALUATION.HHA.COMPLETE',
	FrequenciesRoutineSn: 'FREQUENCIES.ROUTINE.SN',
	FrequenciesRoutineSn_NEEDSSTAFFED: 'FREQUENCIES.ROUTINE.SN.NEEDSSTAFFED',
	FrequenciesRoutineSn_NEEDSPERFORMED: 'FREQUENCIES.ROUTINE.SN.NEEDSPERFORMED',
	FrequenciesRoutineSn_PERFORMING: 'FREQUENCIES.ROUTINE.SN.PERFORMING',
	FrequenciesRoutineSn_PENDINGMISSEDVISIT: 'FREQUENCIES.ROUTINE.SN.PENDINGMISSEDVISIT',
	FrequenciesRoutineSn_MISSED: 'FREQUENCIES.ROUTINE.SN.MISSED',
	FrequenciesRoutineSn_SKIPPED: 'FREQUENCIES.ROUTINE.SN.SKIPPED',
	FrequenciesRoutineSn_CANCELLED: 'FREQUENCIES.ROUTINE.SN.CANCELLED',
	FrequenciesRoutineSn_IDLE: 'FREQUENCIES.ROUTINE.SN.IDLE',
	FrequenciesRoutineSn_PENDING: 'FREQUENCIES.ROUTINE.SN.PENDING',
	FrequenciesRoutineSn_COMPLETE: 'FREQUENCIES.ROUTINE.SN.COMPLETE',
	FrequenciesRoutinePt: 'FREQUENCIES.ROUTINE.PT',
	FrequenciesRoutinePt_NEEDSSTAFFED: 'FREQUENCIES.ROUTINE.PT.NEEDSSTAFFED',
	FrequenciesRoutinePt_NEEDSPERFORMED: 'FREQUENCIES.ROUTINE.PT.NEEDSPERFORMED',
	FrequenciesRoutinePt_PERFORMING: 'FREQUENCIES.ROUTINE.PT.PERFORMING',
	FrequenciesRoutinePt_PENDINGMISSEDVISIT: 'FREQUENCIES.ROUTINE.PT.PENDINGMISSEDVISIT',
	FrequenciesRoutinePt_MISSED: 'FREQUENCIES.ROUTINE.PT.MISSED',
	FrequenciesRoutinePt_SKIPPED: 'FREQUENCIES.ROUTINE.PT.SKIPPED',
	FrequenciesRoutinePt_CANCELLED: 'FREQUENCIES.ROUTINE.PT.CANCELLED',
	FrequenciesRoutinePt_IDLE: 'FREQUENCIES.ROUTINE.PT.IDLE',
	FrequenciesRoutinePt_PENDING: 'FREQUENCIES.ROUTINE.PT.PENDING',
	FrequenciesRoutinePt_COMPLETE: 'FREQUENCIES.ROUTINE.PT.COMPLETE',
	FrequenciesRoutineOt: 'FREQUENCIES.ROUTINE.OT',
	FrequenciesRoutineOt_NEEDSSTAFFED: 'FREQUENCIES.ROUTINE.OT.NEEDSSTAFFED',
	FrequenciesRoutineOt_NEEDSPERFORMED: 'FREQUENCIES.ROUTINE.OT.NEEDSPERFORMED',
	FrequenciesRoutineOt_PERFORMING: 'FREQUENCIES.ROUTINE.OT.PERFORMING',
	FrequenciesRoutineOt_PENDINGMISSEDVISIT: 'FREQUENCIES.ROUTINE.OT.PENDINGMISSEDVISIT',
	FrequenciesRoutineOt_MISSED: 'FREQUENCIES.ROUTINE.OT.MISSED',
	FrequenciesRoutineOt_SKIPPED: 'FREQUENCIES.ROUTINE.OT.SKIPPED',
	FrequenciesRoutineOt_CANCELLED: 'FREQUENCIES.ROUTINE.OT.CANCELLED',
	FrequenciesRoutineOt_IDLE: 'FREQUENCIES.ROUTINE.OT.IDLE',
	FrequenciesRoutineOt_PENDING: 'FREQUENCIES.ROUTINE.OT.PENDING',
	FrequenciesRoutineOt_COMPLETE: 'FREQUENCIES.ROUTINE.OT.COMPLETE',
	FrequenciesRoutineSt: 'FREQUENCIES.ROUTINE.ST',
	FrequenciesRoutineSt_NEEDSSTAFFED: 'FREQUENCIES.ROUTINE.ST.NEEDSSTAFFED',
	FrequenciesRoutineSt_NEEDSPERFORMED: 'FREQUENCIES.ROUTINE.ST.NEEDSPERFORMED',
	FrequenciesRoutineSt_PERFORMING: 'FREQUENCIES.ROUTINE.ST.PERFORMING',
	FrequenciesRoutineSt_PENDINGMISSEDVISIT: 'FREQUENCIES.ROUTINE.ST.PENDINGMISSEDVISIT',
	FrequenciesRoutineSt_MISSED: 'FREQUENCIES.ROUTINE.ST.MISSED',
	FrequenciesRoutineSt_SKIPPED: 'FREQUENCIES.ROUTINE.ST.SKIPPED',
	FrequenciesRoutineSt_CANCELLED: 'FREQUENCIES.ROUTINE.ST.CANCELLED',
	FrequenciesRoutineSt_IDLE: 'FREQUENCIES.ROUTINE.ST.IDLE',
	FrequenciesRoutineSt_PENDING: 'FREQUENCIES.ROUTINE.ST.PENDING',
	FrequenciesRoutineSt_COMPLETE: 'FREQUENCIES.ROUTINE.ST.COMPLETE',
	FrequenciesRoutineMsw: 'FREQUENCIES.ROUTINE.MSW',
	FrequenciesRoutineMsw_NEEDSSTAFFED: 'FREQUENCIES.ROUTINE.MSW.NEEDSSTAFFED',
	FrequenciesRoutineMsw_NEEDSPERFORMED: 'FREQUENCIES.ROUTINE.MSW.NEEDSPERFORMED',
	FrequenciesRoutineMsw_PERFORMING: 'FREQUENCIES.ROUTINE.MSW.PERFORMING',
	FrequenciesRoutineMsw_PENDINGMISSEDVISIT: 'FREQUENCIES.ROUTINE.MSW.PENDINGMISSEDVISIT',
	FrequenciesRoutineMsw_MISSED: 'FREQUENCIES.ROUTINE.MSW.MISSED',
	FrequenciesRoutineMsw_SKIPPED: 'FREQUENCIES.ROUTINE.MSW.SKIPPED',
	FrequenciesRoutineMsw_CANCELLED: 'FREQUENCIES.ROUTINE.MSW.CANCELLED',
	FrequenciesRoutineMsw_IDLE: 'FREQUENCIES.ROUTINE.MSW.IDLE',
	FrequenciesRoutineMsw_PENDING: 'FREQUENCIES.ROUTINE.MSW.PENDING',
	FrequenciesRoutineMsw_COMPLETE: 'FREQUENCIES.ROUTINE.MSW.COMPLETE',
	FrequenciesRoutineHhs: 'FREQUENCIES.ROUTINE.HHA',
	FrequenciesLab: 'FREQUENCIES.LAB',
	FrequenciesLab_DROPPINGOFLABS: 'FREQUENCIES.LAB.DROPPINGOFLABS',
	FrequenciesLab_AWAITINGRESULTS: 'FREQUENCIES.LAB.AWAITINGRESULTS',
	FrequenciesLab_NEEDSSTAFFED: 'FREQUENCIES.LAB.NEEDSSTAFFED',
	FrequenciesLab_NEEDSPERFORMED: 'FREQUENCIES.LAB.NEEDSPERFORMED',
	FrequenciesLab_PERFORMING: 'FREQUENCIES.LAB.PERFORMING',
	FrequenciesLab_PENDINGMISSEDVISIT: 'FREQUENCIES.LAB.PENDINGMISSEDVISIT',
	FrequenciesLab_MISSED: 'FREQUENCIES.LAB.MISSED',
	FrequenciesLab_SKIPPED: 'FREQUENCIES.LAB.SKIPPED',
	FrequenciesLab_CANCELLED: 'FREQUENCIES.LAB.CANCELLED',
	FrequenciesLab_IDLE: 'FREQUENCIES.LAB.IDLE',
	FrequenciesLab_PENDING: 'FREQUENCIES.LAB.PENDING',
	FrequenciesLab_COMPLETE: 'FREQUENCIES.LAB.COMPLETE',
	OrderPatientPhysicians: 'ORDER.PATIENTPHYSICIANS',
	OrderPatientPhysicians_DATAENTRY: 'ORDER.PATIENTPHYSICIANS.DATAENTRY',
	OrderPatientPhysicians_DATAENTERED: 'ORDER.PATIENTPHYSICIANS.DATAENTERED',
	OrderPatientPhysicians_INITIALVERIFICATION: 'ORDER.PATIENTPHYSICIANS.INITIALVERIFICATION',
	OrderPatientPhysicians_VERIFIED: 'ORDER.PATIENTPHYSICIANS.VERIFIED',
	OrderPatientPhysicians_SKIPPED: 'ORDER.PATIENTPHYSICIANS.SKIPPED',
	OrderPatientPhysicians_CANCELLED: 'ORDER.PATIENTPHYSICIANS.CANCELLED',
	OrderPatientPhysicians_IDLE: 'ORDER.PATIENTPHYSICIANS.IDLE',
	OrderPatientPhysicians_PENDING: 'ORDER.PATIENTPHYSICIANS.PENDING',
	OrderPatientPhysicians_COMPLETE: 'ORDER.PATIENTPHYSICIANS.COMPLETE',
	OrderPhysicianSignature: 'ORDER.PHYSICIANSIGNATURE',
	OrderInProgress: 'ORDER.INPROGRESS',
	OrderDrafted: 'ORDER.DRAFTED',
	OrderDrafted_DRAFTED: 'ORDER.DRAFTED.DRAFTED',
	OrderDrafted_WAITINGCOSIGNATURE: 'ORDER.DRAFTED.WAITINGCOSIGNATURE',
	OrderDrafted_INREVIEW: 'ORDER.DRAFTED.INREVIEW',
	OrderDrafted_SENTTOPHYSICIAN: 'ORDER.DRAFTED.SENTTOPHYSICIAN',
	OrderDrafted_SKIPPED: 'ORDER.DRAFTED.SKIPPED',
	OrderDrafted_CANCELLED: 'ORDER.DRAFTED.CANCELLED',
	OrderDrafted_IDLE: 'ORDER.DRAFTED.IDLE',
	OrderDrafted_PENDING: 'ORDER.DRAFTED.PENDING',
	OrderDrafted_COMPLETE: 'ORDER.DRAFTED.COMPLETE',
	Oasis302Soc: 'OASIS.302.SOC',
	Oasis302Soc_WAITINGFORCOMPREHENSIVEASSESSMENT: 'OASIS.302.SOC.WAITINGFORCOMPREHENSIVEASSESSMENT',
	Oasis302Soc_PERFORMING: 'OASIS.302.SOC.PERFORMING',
	Oasis302Soc_WAITINGSUBMISSION: 'OASIS.302.SOC.WAITINGSUBMISSION',
	Oasis302Soc_PERFORMED: 'OASIS.302.SOC.PERFORMED',
	Oasis302Soc_SKIPPED: 'OASIS.302.SOC.SKIPPED',
	Oasis302Soc_CANCELLED: 'OASIS.302.SOC.CANCELLED',
	Oasis302Soc_IDLE: 'OASIS.302.SOC.IDLE',
	Oasis302Soc_PENDING: 'OASIS.302.SOC.PENDING',
	Oasis302Soc_COMPLETE: 'OASIS.302.SOC.COMPLETE',
	Oasis302PtCollaboration: 'OASIS.302.SOC.PT.COLLABORATION',
	Oasis302PtCollaboration_PERFORMING: 'OASIS.302.SOC.PT.COLLABORATION.PERFORMING',
	Oasis302PtCollaboration_WAITINGSUBMISSION: 'OASIS.302.SOC.PT.COLLABORATION.WAITINGSUBMISSION',
	Oasis302PtCollaboration_PERFORMED: 'OASIS.302.SOC.PT.COLLABORATION.PERFORMED',
	Oasis302PtCollaboration_SKIPPED: 'OASIS.302.SOC.PT.COLLABORATION.SKIPPED',
	Oasis302PtCollaboration_CANCELLED: 'OASIS.302.SOC.PT.COLLABORATION.CANCELLED',
	Oasis302PtCollaboration_IDLE: 'OASIS.302.SOC.PT.COLLABORATION.IDLE',
	Oasis302PtCollaboration_PENDING: 'OASIS.302.SOC.PT.COLLABORATION.PENDING',
	Oasis302PtCollaboration_COMPLETE: 'OASIS.302.SOC.PT.COLLABORATION.COMPLETE',
	Oasis302Rec: 'OASIS.302.REC',
	Oasis302Rec_WAITINGFORCOMPREHENSIVEASSESSMENT: 'OASIS.302.REC.WAITINGFORCOMPREHENSIVEASSESSMENT',
	Oasis302Rec_PERFORMING: 'OASIS.302.REC.PERFORMING',
	Oasis302Rec_WAITINGSUBMISSION: 'OASIS.302.REC.WAITINGSUBMISSION',
	Oasis302Rec_PERFORMED: 'OASIS.302.REC.PERFORMED',
	Oasis302Rec_SKIPPED: 'OASIS.302.REC.SKIPPED',
	Oasis302Rec_CANCELLED: 'OASIS.302.REC.CANCELLED',
	Oasis302Rec_IDLE: 'OASIS.302.REC.IDLE',
	Oasis302Rec_PENDING: 'OASIS.302.REC.PENDING',
	Oasis302Rec_COMPLETE: 'OASIS.302.REC.COMPLETE',
	Oasis302Dis: 'OASIS.302.DC',
	Oasis302Dis_WAITINGFORCOMPREHENSIVEASSESSMENT: 'OASIS.302.DC.WAITINGFORCOMPREHENSIVEASSESSMENT',
	Oasis302Dis_PERFORMING: 'OASIS.302.DC.PERFORMING',
	Oasis302Dis_WAITINGSUBMISSION: 'OASIS.302.DC.WAITINGSUBMISSION',
	Oasis302Dis_PERFORMED: 'OASIS.302.DC.PERFORMED',
	Oasis302Dis_SKIPPED: 'OASIS.302.DC.SKIPPED',
	Oasis302Dis_CANCELLED: 'OASIS.302.DC.CANCELLED',
	Oasis302Dis_IDLE: 'OASIS.302.DC.IDLE',
	Oasis302Dis_PENDING: 'OASIS.302.DC.PENDING',
	Oasis302Dis_COMPLETE: 'OASIS.302.DC.COMPLETE',
	Oasis302Fu: 'OASIS.302.FU',
	Oasis302Fu_WAITINGFORCOMPREHENSIVEASSESSMENT: 'OASIS.302.FU.WAITINGFORCOMPREHENSIVEASSESSMENT',
	Oasis302Fu_PERFORMING: 'OASIS.302.FU.PERFORMING',
	Oasis302Fu_WAITINGSUBMISSION: 'OASIS.302.FU.WAITINGSUBMISSION',
	Oasis302Fu_PERFORMED: 'OASIS.302.FU.PERFORMED',
	Oasis302Fu_SKIPPED: 'OASIS.302.FU.SKIPPED',
	Oasis302Fu_CANCELLED: 'OASIS.302.FU.CANCELLED',
	Oasis302Fu_IDLE: 'OASIS.302.FU.IDLE',
	Oasis302Fu_PENDING: 'OASIS.302.FU.PENDING',
	Oasis302Fu_COMPLETE: 'OASIS.302.FU.COMPLETE',
	Oasis302Roc: 'OASIS.302.ROC',
	Oasis302Roc_WAITINGFORCOMPREHENSIVEASSESSMENT: 'OASIS.302.ROC.WAITINGFORCOMPREHENSIVEASSESSMENT',
	Oasis302Roc_PERFORMING: 'OASIS.302.ROC.PERFORMING',
	Oasis302Roc_WAITINGSUBMISSION: 'OASIS.302.ROC.WAITINGSUBMISSION',
	Oasis302Roc_PERFORMED: 'OASIS.302.ROC.PERFORMED',
	Oasis302Roc_SKIPPED: 'OASIS.302.ROC.SKIPPED',
	Oasis302Roc_CANCELLED: 'OASIS.302.ROC.CANCELLED',
	Oasis302Roc_IDLE: 'OASIS.302.ROC.IDLE',
	Oasis302Roc_PENDING: 'OASIS.302.ROC.PENDING',
	Oasis302Roc_COMPLETE: 'OASIS.302.ROC.COMPLETE',
	OasisAddendum: 'OASIS.ADDENDUM',
	OasisAddendum_NEEDSRESPONSE: 'OASIS.ADDENDUM.NEEDSRESPONSE',
	OasisAddendum_SKIPPED: 'OASIS.ADDENDUM.SKIPPED',
	OasisAddendum_CANCELLED: 'OASIS.ADDENDUM.CANCELLED',
	OasisAddendum_IDLE: 'OASIS.ADDENDUM.IDLE',
	OasisAddendum_PENDING: 'OASIS.ADDENDUM.PENDING',
	OasisAddendum_COMPLETE: 'OASIS.ADDENDUM.COMPLETE',
	PlanOfCareLocatorItems: 'PLANOFCARE.LOCATORITEMS',
	PlanOfCareLocatorItems_PERFORMING: 'PLANOFCARE.LOCATORITEMS.PERFORMING',
	PlanOfCareLocatorItems_ASSESSMENTSCOMPLETED: 'PLANOFCARE.LOCATORITEMS.ASSESSMENTSCOMPLETED',
	PlanOfCareLocatorItems_SKIPPED: 'PLANOFCARE.LOCATORITEMS.SKIPPED',
	PlanOfCareLocatorItems_CANCELLED: 'PLANOFCARE.LOCATORITEMS.CANCELLED',
	PlanOfCareLocatorItems_IDLE: 'PLANOFCARE.LOCATORITEMS.IDLE',
	PlanOfCareLocatorItems_PENDING: 'PLANOFCARE.LOCATORITEMS.PENDING',
	PlanOfCareLocatorItems_COMPLETE: 'PLANOFCARE.LOCATORITEMS.COMPLETE',
	DmeIdentification: 'DME.IDENTIFICATION',
	DmeIdentification_IDENTIFYINGDME: 'DME.IDENTIFICATION.IDENTIFYINGDME',
	DmeIdentification_DMEDOCUMENTED: 'DME.IDENTIFICATION.DMEDOCUMENTED',
	DmeIdentification_SKIPPED: 'DME.IDENTIFICATION.SKIPPED',
	DmeIdentification_CANCELLED: 'DME.IDENTIFICATION.CANCELLED',
	DmeIdentification_IDLE: 'DME.IDENTIFICATION.IDLE',
	DmeIdentification_PENDING: 'DME.IDENTIFICATION.PENDING',
	DmeIdentification_COMPLETE: 'DME.IDENTIFICATION.COMPLETE',
	DiagnosesCoding: 'DIAGNOSES.CODING',
	DiagnosesCoding_PRECODINGDIAGNOSES: 'DIAGNOSES.CODING.PRECODINGDIAGNOSES',
	DiagnosesCoding_WAITINGFORINITIALASSESSMENT: 'DIAGNOSES.CODING.WAITINGFORINITIALASSESSMENT',
	DiagnosesCoding_CODING: 'DIAGNOSES.CODING.CODING',
	DiagnosesCoding_DIAGNOSESDOCUMENTED: 'DIAGNOSES.CODING.DIAGNOSESDOCUMENTED',
	DiagnosesCoding_POSTCODING: 'DIAGNOSES.CODING.POSTCODING',
	DiagnosesCoding_POSTCODED: 'DIAGNOSES.CODING.POSTCODED',
	DiagnosesCoding_SKIPPED: 'DIAGNOSES.CODING.SKIPPED',
	DiagnosesCoding_CANCELLED: 'DIAGNOSES.CODING.CANCELLED',
	DiagnosesCoding_IDLE: 'DIAGNOSES.CODING.IDLE',
	DiagnosesCoding_PENDING: 'DIAGNOSES.CODING.PENDING',
	DiagnosesCoding_COMPLETE: 'DIAGNOSES.CODING.COMPLETE',
	DischargePlan: 'DISCHARGEPLAN',
	DischargePlan_BUILDINGDISCHARGEPLAN: 'DISCHARGEPLAN.BUILDINGDISCHARGEPLAN',
	DischargePlan_DISCHARGEPLANDOCUMENTED: 'DISCHARGEPLAN.DISCHARGEPLANDOCUMENTED',
	DischargePlan_SKIPPED: 'DISCHARGEPLAN.SKIPPED',
	DischargePlan_CANCELLED: 'DISCHARGEPLAN.CANCELLED',
	DischargePlan_IDLE: 'DISCHARGEPLAN.IDLE',
	DischargePlan_PENDING: 'DISCHARGEPLAN.PENDING',
	DischargePlan_COMPLETE: 'DISCHARGEPLAN.COMPLETE',
	DisciplineDischargePlanSn: 'DISCHARGEPLAN.DISCIPLINEPLAN.SN',
	DisciplineDischargePlanSn_DISCIPLINEDISCHARGEPLANNING: 'DISCHARGEPLAN.DISCIPLINEPLAN.SN.DISCIPLINEDISCHARGEPLANNING',
	DisciplineDischargePlanSn_DISCPLINEDISCHARGEPLANDOCUMENTED: 'DISCHARGEPLAN.DISCIPLINEPLAN.SN.DISCPLINEDISCHARGEPLANDOCUMENTED',
	DisciplineDischargePlanSn_SKIPPED: 'DISCHARGEPLAN.DISCIPLINEPLAN.SN.SKIPPED',
	DisciplineDischargePlanSn_CANCELLED: 'DISCHARGEPLAN.DISCIPLINEPLAN.SN.CANCELLED',
	DisciplineDischargePlanSn_IDLE: 'DISCHARGEPLAN.DISCIPLINEPLAN.SN.IDLE',
	DisciplineDischargePlanSn_PENDING: 'DISCHARGEPLAN.DISCIPLINEPLAN.SN.PENDING',
	DisciplineDischargePlanSn_COMPLETE: 'DISCHARGEPLAN.DISCIPLINEPLAN.SN.COMPLETE',
	DisciplineDischargePlanPt: 'DISCHARGEPLAN.DISCIPLINEPLAN.PT',
	DisciplineDischargePlanPt_DISCIPLINEDISCHARGEPLANNING: 'DISCHARGEPLAN.DISCIPLINEPLAN.PT.DISCIPLINEDISCHARGEPLANNING',
	DisciplineDischargePlanPt_DISCPLINEDISCHARGEPLANDOCUMENTED: 'DISCHARGEPLAN.DISCIPLINEPLAN.PT.DISCPLINEDISCHARGEPLANDOCUMENTED',
	DisciplineDischargePlanPt_SKIPPED: 'DISCHARGEPLAN.DISCIPLINEPLAN.PT.SKIPPED',
	DisciplineDischargePlanPt_CANCELLED: 'DISCHARGEPLAN.DISCIPLINEPLAN.PT.CANCELLED',
	DisciplineDischargePlanPt_IDLE: 'DISCHARGEPLAN.DISCIPLINEPLAN.PT.IDLE',
	DisciplineDischargePlanPt_PENDING: 'DISCHARGEPLAN.DISCIPLINEPLAN.PT.PENDING',
	DisciplineDischargePlanPt_COMPLETE: 'DISCHARGEPLAN.DISCIPLINEPLAN.PT.COMPLETE',
	DisciplineDischargePlanOt: 'DISCHARGEPLAN.DISCIPLINEPLAN.OT',
	DisciplineDischargePlanOt_DISCIPLINEDISCHARGEPLANNING: 'DISCHARGEPLAN.DISCIPLINEPLAN.OT.DISCIPLINEDISCHARGEPLANNING',
	DisciplineDischargePlanOt_DISCPLINEDISCHARGEPLANDOCUMENTED: 'DISCHARGEPLAN.DISCIPLINEPLAN.OT.DISCPLINEDISCHARGEPLANDOCUMENTED',
	DisciplineDischargePlanOt_SKIPPED: 'DISCHARGEPLAN.DISCIPLINEPLAN.OT.SKIPPED',
	DisciplineDischargePlanOt_CANCELLED: 'DISCHARGEPLAN.DISCIPLINEPLAN.OT.CANCELLED',
	DisciplineDischargePlanOt_IDLE: 'DISCHARGEPLAN.DISCIPLINEPLAN.OT.IDLE',
	DisciplineDischargePlanOt_PENDING: 'DISCHARGEPLAN.DISCIPLINEPLAN.OT.PENDING',
	DisciplineDischargePlanOt_COMPLETE: 'DISCHARGEPLAN.DISCIPLINEPLAN.OT.COMPLETE',
	DisciplineDischargePlanSt: 'DISCHARGEPLAN.DISCIPLINEPLAN.ST',
	DisciplineDischargePlanSt_DISCIPLINEDISCHARGEPLANNING: 'DISCHARGEPLAN.DISCIPLINEPLAN.ST.DISCIPLINEDISCHARGEPLANNING',
	DisciplineDischargePlanSt_DISCPLINEDISCHARGEPLANDOCUMENTED: 'DISCHARGEPLAN.DISCIPLINEPLAN.ST.DISCPLINEDISCHARGEPLANDOCUMENTED',
	DisciplineDischargePlanSt_SKIPPED: 'DISCHARGEPLAN.DISCIPLINEPLAN.ST.SKIPPED',
	DisciplineDischargePlanSt_CANCELLED: 'DISCHARGEPLAN.DISCIPLINEPLAN.ST.CANCELLED',
	DisciplineDischargePlanSt_IDLE: 'DISCHARGEPLAN.DISCIPLINEPLAN.ST.IDLE',
	DisciplineDischargePlanSt_PENDING: 'DISCHARGEPLAN.DISCIPLINEPLAN.ST.PENDING',
	DisciplineDischargePlanSt_COMPLETE: 'DISCHARGEPLAN.DISCIPLINEPLAN.ST.COMPLETE',
	DisciplineDischargePlanMsw: 'DISCHARGEPLAN.DISCIPLINEPLAN.MSW',
	DisciplineDischargePlanMsw_DISCIPLINEDISCHARGEPLANNING: 'DISCHARGEPLAN.DISCIPLINEPLAN.MSW.DISCIPLINEDISCHARGEPLANNING',
	DisciplineDischargePlanMsw_DISCPLINEDISCHARGEPLANDOCUMENTED: 'DISCHARGEPLAN.DISCIPLINEPLAN.MSW.DISCPLINEDISCHARGEPLANDOCUMENTED',
	DisciplineDischargePlanMsw_SKIPPED: 'DISCHARGEPLAN.DISCIPLINEPLAN.MSW.SKIPPED',
	DisciplineDischargePlanMsw_CANCELLED: 'DISCHARGEPLAN.DISCIPLINEPLAN.MSW.CANCELLED',
	DisciplineDischargePlanMsw_IDLE: 'DISCHARGEPLAN.DISCIPLINEPLAN.MSW.IDLE',
	DisciplineDischargePlanMsw_PENDING: 'DISCHARGEPLAN.DISCIPLINEPLAN.MSW.PENDING',
	DisciplineDischargePlanMsw_COMPLETE: 'DISCHARGEPLAN.DISCIPLINEPLAN.MSW.COMPLETE',
	DisciplineDischargePlanHha: 'DISCHARGEPLAN.DISCIPLINEPLAN.HHA',
	EmergencyPlanning: 'EMERGENCYPLANNING',
	EmergencyPlanning_BUILDINGEMERGENCYPLAN: 'EMERGENCYPLANNING.BUILDINGEMERGENCYPLAN',
	EmergencyPlanning_EMERGENCYPLANDOCUMENTED: 'EMERGENCYPLANNING.EMERGENCYPLANDOCUMENTED',
	EmergencyPlanning_SKIPPED: 'EMERGENCYPLANNING.SKIPPED',
	EmergencyPlanning_CANCELLED: 'EMERGENCYPLANNING.CANCELLED',
	EmergencyPlanning_IDLE: 'EMERGENCYPLANNING.IDLE',
	EmergencyPlanning_PENDING: 'EMERGENCYPLANNING.PENDING',
	EmergencyPlanning_COMPLETE: 'EMERGENCYPLANNING.COMPLETE',
	WoundAssessment: 'WOUND.ASSESSMENT',
	WoundAssessment_PERFORMINGASSESSMENT: 'WOUND.ASSESSMENT.PERFORMINGASSESSMENT',
	WoundAssessment_SKIPPED: 'WOUND.ASSESSMENT.SKIPPED',
	WoundAssessment_CANCELLED: 'WOUND.ASSESSMENT.CANCELLED',
	WoundAssessment_IDLE: 'WOUND.ASSESSMENT.IDLE',
	WoundAssessment_PENDING: 'WOUND.ASSESSMENT.PENDING',
	WoundAssessment_COMPLETE: 'WOUND.ASSESSMENT.COMPLETE',
	WoundIdentification: 'WOUND.IDENTIFICATION',
	WoundIdentification_WAITINGFORVISIT: 'WOUND.IDENTIFICATION.WAITINGFORVISIT',
	WoundIdentification_IDENTIFYINGWOUNDS: 'WOUND.IDENTIFICATION.IDENTIFYINGWOUNDS',
	WoundIdentification_SKIPPED: 'WOUND.IDENTIFICATION.SKIPPED',
	WoundIdentification_CANCELLED: 'WOUND.IDENTIFICATION.CANCELLED',
	WoundIdentification_IDLE: 'WOUND.IDENTIFICATION.IDLE',
	WoundIdentification_PENDING: 'WOUND.IDENTIFICATION.PENDING',
	WoundIdentification_COMPLETE: 'WOUND.IDENTIFICATION.COMPLETE',
	PlanOfCareReview: 'CERTIFICATIONREVIEW',
	PlanOfCareReview_INPROGRESS: 'CERTIFICATIONREVIEW.INPROGRESS',
	PlanOfCareReview_SKIPPED: 'CERTIFICATIONREVIEW.SKIPPED',
	PlanOfCareReview_CANCELLED: 'CERTIFICATIONREVIEW.CANCELLED',
	PlanOfCareReview_IDLE: 'CERTIFICATIONREVIEW.IDLE',
	PlanOfCareReview_PENDING: 'CERTIFICATIONREVIEW.PENDING',
	PlanOfCareReview_COMPLETE: 'CERTIFICATIONREVIEW.COMPLETE',
	ConfirmPhysicianTriggers: 'CONFIRMPHYSICIANTRIGGERS',
	NotifyPhysician: 'NOTIFYPHYSICIAN',
	NotifyPhysician_WAITINGFORNOTIFICATION: 'NOTIFYPHYSICIAN.WAITINGFORNOTIFICATION',
	NotifyPhysician_SKIPPED: 'NOTIFYPHYSICIAN.SKIPPED',
	NotifyPhysician_CANCELLED: 'NOTIFYPHYSICIAN.CANCELLED',
	NotifyPhysician_IDLE: 'NOTIFYPHYSICIAN.IDLE',
	NotifyPhysician_PENDING: 'NOTIFYPHYSICIAN.PENDING',
	NotifyPhysician_COMPLETE: 'NOTIFYPHYSICIAN.COMPLETE',
};
